module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.datas), function(data, key) {
    return (data && data.length) ? _c('div', {
      key: key,
      staticClass: "ushk-flash__group J_flash_group"
    }, [_c('div', {
      staticClass: "ushk-flash__date J_flash_date"
    }, [_c('dl', [_c('dt', [_vm._v(_vm._s(_vm.getDay(key)))]), _c('dd', [_vm._v(_vm._s(_vm.getMonth(key)) + "月")])])]), _vm._v(" "), _vm._l((data), function(item) {
      return _c('ushk-message', {
        key: item.id,
        attrs: {
          "did": _vm.did,
          "data": item
        },
        on: {
          "on-remark-click": _vm.onRemarkClick
        },
        nativeOn: {
          "mouseenter": function($event) {
            return _vm.onMouseenter($event)
          },
          "mouseleave": function($event) {
            return _vm.onMouseleave($event)
          },
          "click": function($event) {
            return _vm.onClick($event)
          }
        }
      })
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('remark-dialog', {
    attrs: {
      "remarkData": _vm.remarkData
    },
    model: {
      value: (_vm.isShowRemarkDialog),
      callback: function($$v) {
        _vm.isShowRemarkDialog = $$v
      },
      expression: "isShowRemarkDialog"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ab61ab4","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/MessageGroup.vue
// module id = gzg6
// module chunks = 1